import { render, staticRenderFns } from "./exclusion.vue?vue&type=template&id=c62e7412&scoped=true"
import script from "./exclusion.vue?vue&type=script&lang=js"
export * from "./exclusion.vue?vue&type=script&lang=js"
import style0 from "./exclusion.vue?vue&type=style&index=0&id=c62e7412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62e7412",
  null
  
)

export default component.exports